import React from 'react';
import Button from '../../../../../components/Button';
import FixedBottomNavBar from '../../../../../components/FixedBottomNavBar';
import { RECOMMEND_EVENT_COPY_URL_PATH } from '../../../../../constants/service/common/urlConstants';
import { reDirectPage, setDetailPageUrl } from '../../../../../lib/common';
import './RecommendEventDetailNavbar.scss';

const RecommendEventDetailNavbar = (props) => {
  const { recommendEventId } = props;

  return (
    <FixedBottomNavBar className="recommend-event-detail-navbar">
      <div className="button-group">
        <Button
          color="primary"
          text="복사하기"
          onClick={() => reDirectPage({ path: setDetailPageUrl(RECOMMEND_EVENT_COPY_URL_PATH, recommendEventId) })}
        />
      </div>
    </FixedBottomNavBar>
  );
};

export default RecommendEventDetailNavbar;
